module.exports = __webpack_public_path__ + "static/header-tech-e6d5ce738fc2cb8ccf59aaa4a9ba1ad4.svg";